import { render, staticRenderFns } from "./BibAutocomplete.vue?vue&type=template&id=6989274f&scoped=true"
import script from "./BibAutocomplete.vue?vue&type=script&lang=js"
export * from "./BibAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BibAutocomplete.vue?vue&type=style&index=0&id=6989274f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989274f",
  null
  
)

export default component.exports